import React from 'react';
import { calculatePrice } from './utils';

class OverviewSection extends React.Component {

    calculatePrice = () => {
        let { reservation, reservationLength, app } = this.props;
        return calculatePrice(reservation, reservationLength, app);
    }

    render() {
        let { reservation, app } = this.props;
        const isCamping = app.state.activeCalendar?.type === 'accommodation';

        const adults = parseInt(reservation.adults_count) || 0;
        const children = parseInt(reservation.children_count) || 0;
        const totalPeople = adults + children;
        
        let stayPrice = this.calculatePrice();

        if (this.props.returnPriceOnly) {
            return stayPrice;
        }

        return (
            <div className="flex items-center justify-between py-2.5">
                <div className="flex items-center gap-3">
                    <div className={`w-2 h-2 rounded-full ${isCamping ? 'bg-taborisko-orange' : 'bg-splavma-orange'}`}></div>
                    <span className="text-sm font-medium text-gray-700">
                        Ubytovanie v táborisku ({totalPeople}os)
                    </span>
                </div>
                <span className="text-sm font-bold text-gray-900">
                    {stayPrice.toFixed(2)}&nbsp;€
                </span>
            </div>
        );
    }
}

export default OverviewSection;
